import React from 'react'
import { Box } from '@mui/material'
import Layout from './Layout'

interface CoreLayoutProps {
    children: React.ReactNode
}

/**
 * CoreLayout - Layout for public routes (landing, login, register, privacy).
 *
 * Features:
 * - Full navigation with auth links (login/register)
 * - Footer
 * - Skip to main content link
 * - Consistent bottom padding for mobile and desktop
 */
export default function CoreLayout({ children }: CoreLayoutProps) {
    return (
        <Layout variant="full" showAuthLinks={true}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    // Consistent bottom padding across breakpoints (matches PageLayout)
                    pb: { xs: 0, sm: 1 },
                }}
            >
                {children}
            </Box>
        </Layout>
    )
}
